import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction, IPayload } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IPopularize, defaultValue, ISearchForm } from 'app/shared/model/popularize.model';
import { flattenKey } from 'app/shared/util/object-utils';
import * as qs from 'qs';
import { camelCase, flatten } from 'lodash';
import { PopularizeChannel } from 'app/shared/model/popularize-record.model';
// 请求
export const ACTION_TYPES = {
  FETCH_POPULARIZE_LIST: 'popularize/FETCH_POPULARIZE_LIST',
  FETCH_POPULARIZE: 'popularize/FETCH_POPULARIZE',
  CREATE_POPULARIZE: 'popularize/CREATE_POPULARIZE',
  BATCH_CREATE_POPULARIZE: 'popularize/BATCH_CREATE_POPULARIZE',
  UPDATE_POPULARIZE: 'popularize/UPDATE_POPULARIZE',
  DELETE_POPULARIZE: 'popularize/DELETE_POPULARIZE',
  RESET: 'popularize/RESET'
};
// state
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPopularize>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type PopularizeState = Readonly<typeof initialState>;

// Reducer

export default (state: PopularizeState = initialState, action): PopularizeState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_POPULARIZE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_POPULARIZE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_POPULARIZE):
    case REQUEST(ACTION_TYPES.BATCH_CREATE_POPULARIZE):
    case REQUEST(ACTION_TYPES.UPDATE_POPULARIZE):
    case REQUEST(ACTION_TYPES.DELETE_POPULARIZE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_POPULARIZE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_POPULARIZE):
    case FAILURE(ACTION_TYPES.CREATE_POPULARIZE):
    case FAILURE(ACTION_TYPES.BATCH_CREATE_POPULARIZE):
    case FAILURE(ACTION_TYPES.UPDATE_POPULARIZE):
    case FAILURE(ACTION_TYPES.DELETE_POPULARIZE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_POPULARIZE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_POPULARIZE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.BATCH_CREATE_POPULARIZE):
      return {
        ...state,
        updating: false,
        updateSuccess: false
      };
    case SUCCESS(ACTION_TYPES.CREATE_POPULARIZE):
    case SUCCESS(ACTION_TYPES.UPDATE_POPULARIZE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_POPULARIZE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
export declare type ICrudGetListAction<T> = (
  page?: number,
  size?: number,
  sort?: string,
  searchForm?: ISearchForm
) => IPayload<T> | ((dispatch: any) => IPayload<T>);
const apiUrl = 'api/popularizes'; // 推广管理

// Actions
// 推广管理列表
export const getEntities: ICrudGetListAction<IPopularize> = (page, size, sort, searchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_POPULARIZE_LIST,
    payload: axios.get<IPopularize>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    })
  };
};
// 推送到平台
export const syncSend = (id, ...channels) => async dispatch => {
  const requestUrl = `${apiUrl}/${id}/sync/send`;
  const pushPopularize: IPopularize = { id };
  flatten(channels).forEach(channel => {
    pushPopularize[camelCase(`has${channel}`)] = true;
  });
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_POPULARIZE,
    payload: axios.put(requestUrl, { ...pushPopularize })
  });
  return result;
};

// quxi
export const syncCancel = (id, ...channels) => async dispatch => {
  const requestUrl = `${apiUrl}/${id}/sync/cancel`;
  const cancelPopularize: IPopularize = { id };
  flatten(channels).forEach(channel => {
    cancelPopularize[camelCase(`has${channel}`)] = false;
  });
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_POPULARIZE,
    payload: axios.put(requestUrl, { ...cancelPopularize })
  });
  return result;
};

export const getEntity: ICrudGetAction<IPopularize> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_POPULARIZE,
    payload: axios.get<IPopularize>(requestUrl)
  };
};
// 创建推广管理
export const createEntity: ICrudPutAction<IPopularize> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_POPULARIZE,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 合并创建推广管理
export const batchCreateEntity = entitys => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.BATCH_CREATE_POPULARIZE,
    payload: axios.post(`${apiUrl}/createBatch`, entitys)
  });
  return result;
};
// 更新推广管理
export const updateEntity: ICrudPutAction<IPopularize> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_POPULARIZE,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 删除推广管理
export const deleteEntity: ICrudDeleteAction<IPopularize> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_POPULARIZE,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};
export const canPush = (config: string[], channel: string) => config.includes(channel);

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
